// Copyright (c) 2022. Heusala Group Oy <info@heusalagroup.fi>. All rights reserved.

import { useServiceEvent } from "../../../../io/hyperify/frontend/hooks/useServiceEvent";
import { StoreCartService, StoreCartServiceEvent } from "../../../../io/hyperify/core/StoreCartService";
import { VoidCallback } from "../../../../io/hyperify/core/interfaces/callbacks";

export function useCartUpdatedEvent (
    callback: VoidCallback
) {
    return useServiceEvent<StoreCartServiceEvent>(
        StoreCartService,
        StoreCartServiceEvent.CART_UPDATED,
        callback
    );
}
